import {useEffect} from 'react';

// react-router-dom components
import {useLocation, useNavigate} from 'react-router-dom';

// @mui material components
import Card from '@mui/material/Card';

// Material Dashboard 2 React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';

// Authentication layout components
import BasicLayout from 'layouts/authentication/components/BasicLayout';

// Images
import bgImage from 'assets/images/bg-sign-in-basic.jpeg';
import {Controller, useForm} from 'react-hook-form';
import {loginSchema} from 'schemas/auth/loginSchema';
import {yupResolver} from '@hookform/resolvers/yup';
import {Loading, Notify} from 'notiflix';
import {useDispatch, useSelector} from 'react-redux';
import {loginUser} from 'store/slices/authSlice';

function Basic() {
  const {user, isAuthenticated} = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    formState: {errors},
  } = useForm({
    resolver: yupResolver(loginSchema),
    defaultValues: {
      email: '',
      password: '',
    },
  });

  // Any signed-in admin-panel role should bounce off the sign-in page — module
  // visibility within the panel is handled separately by /my-permissions.
  const isAuthorized = Boolean(user);
  useEffect(() => {
    if (isAuthenticated && isAuthorized) {
      navigate('/dashboard', {replace: true});
    }
  }, [isAuthenticated, isAuthorized]);

  if (isAuthenticated && isAuthorized) {
    return null;
  }

  const handleLogin = async formData => {
    const formValues = {
      email: formData.email.toLowerCase(),
      password: formData.password,
    };
    try {
      Loading.circle('Processing...');
      const data = await dispatch(loginUser(formValues)).unwrap();
      Notify.success(data.message);
    } catch (error) {
      Notify.failure(error?.message || 'Login failed');
    } finally {
      Loading.remove();
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center">
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <form onSubmit={handleSubmit(handleLogin)}>
            <MDBox mb={0}>
              <Controller
                name="email"
                control={control}
                render={({field: controllerField}) => (
                  <MDInput
                    {...controllerField}
                    fullWidth
                    label="Email"
                    type="text"
                    error={!!errors.email}
                    helperText={errors.email?.message}
                    margin="normal"
                  />
                )}
              />
            </MDBox>
            <MDBox mb={0}>
              <Controller
                name="password"
                control={control}
                render={({field: controllerField}) => (
                  <MDInput
                    {...controllerField}
                    fullWidth
                    label="Password"
                    type="password"
                    error={!!errors.password}
                    helperText={errors.password?.message}
                    margin="normal"
                  />
                )}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit">
                sign in
              </MDButton>
            </MDBox>
          </form>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
